import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { functions } from "@poseidon/firebase/firebase";
import { useCallback, useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";

export const useDownloadOpenBankingReport = () => {
  const [loading, setLoading] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [executeCallable] = useHttpsCallable(
    functions,
    "downloadOpenBankingReport"
  );

  const download = useCallback(
    async (sailorId: string) => {
      try {
        setLoading(true);
        const result = (await executeCallable({ sailorId })) as {
          data: { success: boolean; pdf: string; filename: string };
        };

        if (!result?.data?.success) {
          setError("Failed to download report");
          return;
        }

        // Convert base64 to blob and trigger download
        const byteCharacters = atob(result.data.pdf);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = result.data.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setToast("Report downloaded");
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        } else {
          setError("Failed to download report");
        }
      } finally {
        setLoading(false);
      }
    },
    [executeCallable, setError, setToast]
  );

  return { download, loading };
};
